/** External CSS */
import "./index.css"

export const Model3DPage = () => {
    return (<div className="main-container">
        <h2>Under Construction</h2>
    </div>);
}